import { render, staticRenderFns } from "./FamilyPoliciesSearchPanel.vue?vue&type=template&id=651f20b9&scoped=true"
import script from "./FamilyPoliciesSearchPanel.vue?vue&type=script&lang=js"
export * from "./FamilyPoliciesSearchPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651f20b9",
  null
  
)

export default component.exports